namespace TabAurous.OMS {

    @Serenity.Decorators.registerEditor()
    export class VoucherMasterEditor extends Serenity.Select2Editor<any, any> {

        constructor(container: JQuery) {
            super(container, null);


            this.addOption("Automatic", "Automatic");
            this.addOption("Manual", "Manual");

        }
    }
}